<template>
<!-- Modal เพิ่ม Template -->
<div class="modal fade" id="addTemplate" tabindex="-1" aria-labelledby="addTemplateLabel" aria-hidden="true">
    <div class="modal-dialog  modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ editingTemplateId ? 'แก้ไข Template' : 'เพิ่ม Template' }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="px-2">
                    <div class="row g-4">
                        <!-- Left Section -->
                        <div class="col-lg-6">
                            <div class="form-section">
                                <h5 class=" mb-3">
                                    <i class="bi bi-gear me-2"></i>ตั้งค่า Template
                                </h5>

                                <div class="mb-4">
                                    <label class="custom-label">
                                        <i class="bi bi-tag me-2"></i>ชื่อ Template
                                    </label>
                                    <input type="text" class="custom-input" placeholder="Enter template name" v-model="template.name">
                                </div>

                                <!-- Add Item Section -->
                                <div class="add-item-section">
                                    <div class="d-flex align-items-center mb-3">
                                        <i class="bi bi-plus-circle-fill text-primary me-2" style="font-size: 1.2rem;"></i>
                                        <h6 class="mb-0 fw-semibold">{{ edit_state ? 'แก้ไขตัวแปร' : 'เพิ่มตัวแปร' }}</h6>
                                    </div>

                                    <div class="item-form">
                                        <div class="mb-3">
                                            <label class="form-label-small">IO type</label>
                                                 <select v-model="template.type" class="custom-input-small">
                                                <option disabled value="">Select type</option>
                                                <option>Data</option>
                                                <option>Control</option>
                                            </select>
                                        </div>

                                             <div class="mb-3">
                                            <label class="form-label-small">Label</label>
                                            <input type="text" class="custom-input-small" placeholder="e.g. Voltage 1" v-model="template.label">
                                        </div>

                                        <div class="mb-3">
                                            <label class="form-label-small">Key</label>
                                            <input type="text" class="custom-input-small" placeholder="e.g. v1" v-model="template.key">
                                        </div>

                                        <div class="mb-3">
                                            <label class="form-label-small">Value Type</label>
                                            <select v-model="template.value_type" class="custom-input-small">
                                                <option disabled value="">Select type</option>
                                                <option>float</option>
                                                <option>int</option>
                                                <option>bool</option>
                                                 <option>timestamp</option>
                                                 <option>json</option>
                                                 <option>array</option>
                                            </select>
                                        </div>

                                        <div class="mb-3">
                                            <label class="form-label-small">Unit</label>
                                            <input type="text" class="custom-input-small" placeholder="e.g. Volt (V)" v-model="template.unit">
                                        </div>

                                        <div class="mb-3">
                                            <label class="form-label-small">Widget Type</label>
                                            <select v-model="template.widget_type" class="custom-input-small">
                                                <option disabled value="">Select widget type</option>
                                                <option>realtime</option>
                                                <option>gauge</option>
                                                <option>chart</option>
                                                <option>notification</option>
                                            </select>
                                        </div>

                                        <div class="text-end">
                                            <button v-if="!edit_state" type="button" class="btn-add-item" @click="addItemToTemplate()">
                                                <i class="bi bi-plus-lg me-2"></i>เพิ่มตัวแปร
                                            </button>
                                            <div v-else>
                                                <button type="button" class="btn btn-secondary me-2" @click="cancleItemEdit()">
                                                    <i class="bi bi-x-lg me-2"></i>ยกเลิก
                                                </button>
                                                <button type="button" class="btn btn-success" @click="saveItemEdit()">
                                                    <i class="bi bi-check-lg me-2"></i>บันทึกการแก้ไข
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Right Section -->
                        <div class="col-lg-6">
                            <div class="form-section">
                                <h5 class=" mb-3">
                                    <i class="bi bi-list-ul me-2"></i>รายการตัวแปร
                                </h5>

                                <div class="items-container">
                                    <div v-if="items.length === 0" class="empty-state">
                                        <i class="bi bi-inbox"></i>
                                        <p>No items added yet</p>
                                        <small>Add items using the form on the left</small>
                                    </div>

                                    <div v-else class="items-grid">
                                        <div class="item-card" v-for="(item, index) in items" :key="index">
                                            <div class="item-content">
                                                <div class="item-label">
                                                    <i class="bi bi-tag-fill me-2"></i>
                                                    {{ item.label }}
                                                </div>
                                                <div class="item-details">
                                                    <span class="badge-custom">{{ item.key }}</span>
                                                    <span class="badge-custom">{{ item.value_type }}</span>
                                                    <span class="badge-custom">{{ item.widget_type }}</span>
                                                </div>
                                            </div>
                                            <div class="btn-group-vertical">
                                                <button class="btn btn-sm btn-warning mb-1" @click="editItem(item, index)">
                                                    <i class="bi bi-pencil"></i>
                                                </button>
                                                <button class="btn btn-sm btn-danger" @click="items.splice(index, 1)">
                                                    <i class="bi bi-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-4 mt-4">
                                    <label class="custom-label">
                                        <i class="bi bi-chat-left-text me-2"></i>รายละเอียดคำอธิบาย
                                    </label>
                                    <textarea class="custom-input" rows="5" placeholder="Add template description..." v-model="template.description"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="button-row mt-5">
                        <button @click="clearForm()" class="btn-clear">
                            <i class="bi bi-arrow-counterclockwise me-2"></i>ล้างค่า
                        </button>
                        <button v-if="!editingTemplateId" @click="createTemplate()" class="btn-create" :disabled="!template.name || items.length === 0">
                            <i class="bi bi-check-circle me-2"></i>สร้าง Template
                        </button>
                        <button v-else @click="updateTemplate()" class="btn-create" :disabled="!template.name || items.length === 0">
                            <i class="bi bi-check-circle me-2"></i>อัพเดท Template
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="dashboard">
    <!-- Header -->
    <header class="header">
        <div class="container">
            <div class="header-content">
                <h1>รายการรูปแบบข้อมูล</h1>
                <div class="search-box">
                    <button type="button" class="btn btn-dark px-3 rounded-5" data-bs-toggle="modal" data-bs-target="#addTemplate" @click="resetModalForCreate()"> + เพิ่ม Template</button>
                </div>
            </div>
        </div>
    </header>

    <!-- Main Content -->
    <div class="container main-content">

        <!-- Customers Table -->
        <div class="customers-section">
            <div class="section-header">
                     <div class="col-12">
                    <div class="" style="font-size: 20px;">รายการรูปแบบข้อมูล (Template)</div>
                  
                </div>
            </div>

           

            <div class="table-wrapper">
                <table class="customers-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>ชื่อ Template ข้อมูล</th>
                            <th>จำนวนค่า Input/Output</th>
                            <th>รายละเอียดเพิ่มเติม</th>
                            <th>แก้ไข/ลบ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list_template" :key="index">
                            <td class="">{{ index+1 }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.device_items?.length || 0 }}</td>
                            <td>{{item.description}}</td>
                            <td>
                                <span class="edit_btn px-1 py-1 rounded-2" @click="openEditModal(item)" style="cursor: pointer;">
                                    <i class="bi bi-pen"></i> แก้ไข
                                </span>
                                <span class="remove_btn px-3 py-1 rounded-2 ms-2" @click="deleteTemplate(item.id)" style="cursor: pointer;">
                                    <i class="bi bi-trash3"></i> ลบ
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="pagination">
                <div class="pagination-info">
                    <!-- Showing data 1 to {{ list_template.length }} of {{ list_template.length }} entries -->
                </div>
                <div class="pagination-controls">
                    <button class="page-btn" @click="prevPage" :disabled="currentPage === 1">
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <button v-for="page in visiblePages" :key="page" :class="['page-btn', { active: currentPage === page }]" @click="currentPage = page">
                        {{ page }}
                    </button>
                    <button class="page-btn" v-if="totalPages > 5">...</button>
                    <button class="page-btn" @click="currentPage = totalPages">{{ totalPages }}</button>
                    <button class="page-btn" @click="nextPage" :disabled="currentPage === totalPages">
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as bootstrap from 'bootstrap';
export default {
    data() {
        return {
            template: {
                label: "",
                name: "",
                key: "",
                type: "Data",
                value_type: "",
                unit: "",
                widget_type: "",
                description: ""
            },
            items: [],
            editIndex: null,
            edit_state: false,
            editingTemplateId: null, // เก็บ ID ของ template ที่กำลังแก้ไข
            list_template: [],
            tableSearch: "",
            sortBy: "Newest",
            currentPage: 1,
            totalPages: 1,
        };
    },
    computed: {
        visiblePages() {
            const pages = [];
            const maxVisible = 5;
            const start = Math.max(1, this.currentPage - 2);
            const end = Math.min(this.totalPages, start + maxVisible - 1);
            
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    methods: {
        addItemToTemplate() {
            if (!this.template.label || !this.template.key || !this.template.value_type || !this.template.widget_type) {
                return;
            }

            this.items.push({
                label: this.template.label,
                key: this.template.key,
                value_type: this.template.value_type,
                unit: this.template.unit,
                type: "Data",
                widget_type: this.template.widget_type,
                order_index: this.items.length + 1
            });

            this.template.label = "";
            this.template.key = "";
            this.template.value_type = "";
            this.template.unit = "";
            this.template.widget_type = "";
        },

        clearForm() {
            this.template.name = "";
            this.template.description = "";
            this.template.label = "";
            this.template.key = "";
            this.template.value_type = "";
            this.template.unit = "";
            this.template.widget_type = "";
            this.items = [];
            this.editingTemplateId = null;
            this.edit_state = false;
            this.editIndex = null;
        },

        resetModalForCreate() {
            this.clearForm();
        },

        async createTemplate() {
            try {
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify({
                        "name": this.template.name,
                        "description": this.template.description,
                        "items": this.items
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                console.log('Template created:', result);
                
                // ปิด modal
                const modal = document.getElementById('addTemplate');
                const modalInstance = bootstrap.Modal.getInstance(modal);
                if (modalInstance) {
                    modalInstance.hide();
                }
                
                // รีเฟรชรายการ
                this.getTemplateList();
                this.clearForm();
            } catch (error) {
                console.error('Error creating template:', error);
                alert('เกิดข้อผิดพลาดในการสร้าง template');
            }
        },

        async updateTemplate() {
            try {
                if (!this.editingTemplateId) {
                    alert('ไม่พบ Template ID');
                    return;
                }

                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify({
                        "id": this.editingTemplateId,
                        "name": this.template.name,
                        "description": this.template.description,
                        "items": this.items
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                console.log('Template updated:', result);
                
                // ปิด modal
                const modal = document.getElementById('addTemplate');
                const modalInstance = bootstrap.Modal.getInstance(modal);
                if (modalInstance) {
                    modalInstance.hide();
                }
                
                // รีเฟรชรายการ
                this.getTemplateList();
                this.clearForm();
            } catch (error) {
                console.error('Error updating template:', error);
                alert('เกิดข้อผิดพลาดในการอัพเดท template');
            }
        },

        openEditModal(templateData) {
            // เก็บ ID ของ template ที่จะแก้ไข
            this.editingTemplateId = templateData.id;
            
            // โหลดข้อมูล template
            this.template.name = templateData.name;
            this.template.description = templateData.description;
            
            // โหลด items โดยเรียงลำดับตาม order_index
            this.items = [...templateData.device_items].sort((a, b) => {
                return (a.order_index || 0) - (b.order_index || 0);
            });
            
            // เปิด modal
            const modal = new bootstrap.Modal(document.getElementById('addTemplate'));
            modal.show();
        },

        saveItemEdit() {
            if (this.editIndex !== null) {
                // อัปเดต items[index] ด้วยค่าจาก template
                this.items[this.editIndex] = {
                    label: this.template.label,
                    key: this.template.key,
                    value_type: this.template.value_type,
                    unit: this.template.unit,
                    type: "Data",
                    widget_type: this.template.widget_type,
                    order_index: this.editIndex + 1
                };
                
                this.edit_state = false;
                this.template.label = "";
                this.template.key = "";
                this.template.value_type = "";
                this.template.unit = "";
                this.template.widget_type = "";
                this.editIndex = null;
            }
        },

        editItem(item, index) {
            this.editIndex = index;
            this.template.label = item.label;
            this.template.key = item.key;
            this.template.value_type = item.value_type;
            this.template.unit = item.unit;
            this.template.widget_type = item.widget_type;
            this.edit_state = true;
        },

        cancleItemEdit() {
            this.template.label = "";
            this.template.key = "";
            this.template.value_type = "";
            this.template.unit = "";
            this.template.widget_type = "";
            this.edit_state = false;
            this.editIndex = null;
        },

        async getTemplateList() {
            try {
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template`, {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                const data = await response.json();
                console.log("success:", data);
                this.list_template = data.data;
                this.totalPages = Math.ceil(this.list_template.length / 10) || 1;
            } catch (error) {
                console.error("Fetch error:", error);
            }
        },

        async deleteTemplate(id) {
            if (!confirm('คุณต้องการลบ template นี้หรือไม่?')) {
                return;
            }

            try {
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template?templateid=${id}`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                alert('ลบ template สำเร็จ');
                this.getTemplateList();
            } catch (error) {
                console.error('Error deleting template:', error);
                alert('เกิดข้อผิดพลาดในการลบ template');
            }
        },

        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },

        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        }
    },
    mounted() {
        this.getTemplateList();
    },
};
</script>
<style scoped>

.edit_btn {
  background: #d4f4dd;
  color: #00ac4f;
  border: 1px solid #00ac4f;
}
.remove_btn{
    background: #ffe2e5;
    color: #fa5a7d;
    border: 1px solid #fa5a7d;
}

.dashboard {
    min-height: 100vh;
    background-color: #f5f6fa;
    
}

.header {
    background: white;
    padding: 20px 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 0px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header h1 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: #1a1a1a;
}

.search-box {
    position: relative;
    width: 300px;
}

.search-box input {
    width: 100%;
    padding: 10px 10px 10px 40px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    background: #f9fafb;
    outline: none;
}

.search-box input:focus {
    border-color: #6366f1;
}

.search-box i {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
}

.main-content {
    padding-top: 40px;
    padding-bottom: 40px;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-bottom: 40px;
}

.stat-card {
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s;
}

.stat-card:hover {
    transform: translateY(-2px);
}

.stat-content {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    flex-shrink: 0;
}

.icon-green {
    background: #d4f4dd;
    color: #00ac4f;
}

.icon-purple {
    background: #e5d9f2;
    color: #8b5cf6;
}

.stat-info {
    flex: 1;
}

.stat-label {
    color: #9ca3af;
    font-size: 14px;
    margin-bottom: 8px;
}

.stat-value {
    font-size: 32px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 8px 0;
}

.stat-change {
    font-size: 13px;
    font-weight: 500;
}

.change-up {
    color: #00ac4f;
}

.change-down {
    color: #fa5a7d;
}

.avatar-group {
    display: flex;
    margin-top: 8px;
}

.avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid white;
    margin-left: -8px;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}

.avatar:first-child {
    margin-left: 0;
}

.customers-section {
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.section-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 8px 0;
}

.active-members {
    color: #16c098;
    font-size: 14px;
    font-weight: 500;
    text-decoration: underline;
}

.search-sort-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.sort-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
}

.sort-wrapper label {
    color: #9ca3af;
    font-size: 14px;
    margin: 0;
}

.sort-select {
    padding: 8px 16px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    color: #6b7280;
    background: white;
    cursor: pointer;
    outline: none;
}

.sort-select:focus {
    border-color: #6366f1;
}

.table-wrapper {
    overflow-x: auto;
}

.customers-table {
    width: 100%;
    min-width: 1100px;
    border-collapse: separate;
    border-spacing: 0;
}

.customers-table thead th {
    padding: 12px 16px;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: #6b7280;
    border-bottom: 1px solid #e5e7eb;
}

.customers-table tbody td {
    padding: 16px;
    font-size: 14px;
    color: #1a1a1a;
    border-bottom: 1px solid #f3f4f6;
}

.customers-table tbody tr:hover {
    background: #f9fafb;
}

.status-badge {
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
    display: inline-block;
    min-width: 70px;
    text-align: center;
}

.status-active {
    background: #d4f4dd;
    color: #00ac4f;
    border: 1px solid #00ac4f;
}

.status-inactive {
    background: #ffe2e5;
    color: #fa5a7d;
    border: 1px solid #fa5a7d;
}

.pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #e5e7eb;
}

.pagination-info {
    color: #9ca3af;
    font-size: 14px;
}

.pagination-controls {
    display: flex;
    gap: 8px;
}

.page-btn {
    width: 32px;
    height: 32px;
    border: 1px solid #e5e7eb;
    background: white;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    color: #6b7280;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    border-color: #6366f1;
    color: #6366f1;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-btn.active {
    background: #6366f1;
    color: white;
    border-color: #6366f1;
}

@media (max-width: 768px) {
    .stats-grid {
        grid-template-columns: 1fr;
    }

    .search-sort-bar {
        flex-direction: column;
        gap: 16px;
        align-items: stretch;
    }

    .search-box {
        width: 100%;
    }

    .table-wrapper {
        overflow-x: scroll;
    }
}

/* add template data */
/* Header Card */
.header-card {
    background: linear-gradient(135deg, #66b3ea 0%, #4b68a2 100%);
    padding: 2rem;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
    color: white;
}

.icon-wrapper {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    backdrop-filter: blur(10px);
}

.header-card h3 {
    color: white;
    margin: 0;
}

.header-card p {
    color: rgba(255, 255, 255, 0.9);
}

/* Form Card */
.form-card {
    background: white;
    padding: 2.5rem;
    border-radius: 16px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
}

.form-section {
    height: 100%;
}

.section-title {
    color: #2d3748;
    font-weight: 600;
    font-size: 1.1rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #e2e8f0;
}

/* Custom Input Styles */
.custom-label {
    display: block;
    font-weight: 500;
    color: #4a5568;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
}

.custom-input {
    width: 100%;
    padding: 0.85rem 1rem;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    background: #fafafa;
}

.custom-input:focus {
    outline: none;
    border-color: #667eea;
    background: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-input::placeholder {
    color: #a0aec0;
}

textarea.custom-input {
    resize: vertical;
}

/* Add Item Section */
.add-item-section {
    background: #f7fafc;
    padding: 1.5rem;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    margin-top: 1.5rem;
}

.item-form {
    margin-top: 1rem;
}

.form-label-small {
    display: block;
    font-weight: 500;
    color: #4a5568;
    margin-bottom: 0.4rem;
    font-size: 0.85rem;
}

.custom-input-small {
    width: 100%;
    padding: 0.65rem 0.85rem;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    background: white;
}

.custom-input-small:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

select.custom-input-small {
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234a5568' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 0.85rem center;
    padding-right: 2.5rem;
}

.btn-add-item {
    padding: 0.65rem 1.5rem;
    border: none;
    background: linear-gradient(135deg, #66b3ea 0%, #4b68a2 100%);
    color: white;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    font-size: 0.9rem;
}

.btn-add-item:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* Items Container */
.items-container {
    background: #f7fafc;
    border-radius: 12px;
    padding: 1.5rem;
    min-height: 300px;
    max-height: 300px;
    overflow-y: auto;
    border: 2px solid #e2e8f0;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #a0aec0;
    text-align: center;
}

.empty-state i {
    font-size: 3rem;
    margin-bottom: 1rem;
    opacity: 0.5;
}

.empty-state p {
    margin: 0;
    font-weight: 500;
    font-size: 1rem;
}

.empty-state small {
    font-size: 0.85rem;
}

.items-grid {
    display: grid;
    gap: 0.75rem;
}

.item-card {
    background: white;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.3s ease;
}

.item-card:hover {
    border-color: #cbd5e0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.item-content {
    flex: 1;
}

.item-label {
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
}

.item-label i {
    color: #667eea;
    font-size: 0.9rem;
}

.item-details {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.badge-custom {
    background: linear-gradient(135deg, #66b3ea 0%, #4b68a2 100%);
    color: white;
    padding: 0.25rem 0.65rem;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 500;
}

.btn-remove {
    background: #fed7d7;
    border: none;
    color: #c53030;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.btn-remove:hover {
    background: #fc8181;
    color: white;
    transform: scale(1.1);
}

/* Scrollbar Styling */
.items-container::-webkit-scrollbar {
    width: 8px;
}

.items-container::-webkit-scrollbar-track {
    background: #e2e8f0;
    border-radius: 10px;
}

.items-container::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 10px;
}

.items-container::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
}

/* Buttons */
.button-row {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding-top: 2rem;
    border-top: 2px solid #e2e8f0;
}

.btn-clear {
    padding: 0.85rem 2rem;
    border: 2px solid #e2e8f0;
    background: white;
    color: #718096;
    border-radius: 10px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
}

.btn-clear:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
    color: #2d3748;
    transform: translateY(-1px);
}

.btn-create {
    padding: 0.85rem 2.5rem;
    border: none;
    background: linear-gradient(135deg, #66b3ea 0%, #4b68a2 100%);
    color: white;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-create:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.btn-create:disabled {
    background: #cbd5e0;
    cursor: not-allowed;
    box-shadow: none;
}

/* Responsive */
@media (max-width: 991px) {
    .form-card {
        padding: 1.5rem;
    }

    .header-card {
        padding: 1.5rem;
    }

    .button-row {
        flex-direction: column-reverse;
    }

    .btn-clear,
    .btn-create {
        width: 100%;
        justify-content: center;
    }
}
</style>
